<template>
    <div v-if="withAction" @click="action" :class="typeClass">
        <span class="sidebar__button button-circle button-circle--better">
            <span class="button-circle__icon" :class="icon"></span>
        </span>
        <p v-if="withText" class="sidebar__text sidebar__text--cus">{{ text }}</p>
    </div>

    <router-link v-else :to="{ name: linkName }" :class="typeClass">
        <span class="sidebar__button button-circle button-circle--better">
            <span class="button-circle__icon" :class="icon"></span>
        </span>
        <p v-if="withText" class="sidebar__text sidebar__text--cus">{{ text }}</p>
    </router-link>
</template>

<script>
    export default {
        props: {
            withText: {
                type: Boolean,
                default: false,
            },
            withAction: {
                type: Boolean,
                default: false,
            },
            icon: {
                type: String,
                default: 'i-home'
            },
            linkName: {
                type: String,
                default: 'home',
            },
            text: {
                type: String,
                default: 'No translation',
            },
            action: {
                type: Function,
                default: () => { console.log('No function') },
            },
        },
        computed: {
            typeClass() {
                return this.withText ? 'sidebar__item--text' : 'sidebar__item';
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Code/sidebar/SidebarItem.vue